import googleImage4Icon from '~/assets/images/ai-image-models/google-image-4.webp'
import wanImageProIcon from '~/assets/images/ai-image-models/wan-2.7-image-pro.webp'
import wanImageIcon from '~/assets/images/ai-image-models/wan-2.7-image.webp'
import gptImage2Icon from '~/assets/images/ai-image-models/gpt-image-2.webp'
import nanoBanana2LiteIcon from '~/assets/images/ai-image-models/nano-banana-2-lite.webp'
import nanoBanana2Icon from '~/assets/images/ai-image-models/nano-banana-2.webp'
import grokImagineIcon from '~/assets/images/ai-image-models/grok-imagine.webp'

export const AI_IMAGE_MODEL_ICON_BY_ID = {
  'google-image-4': googleImage4Icon,
  'wan-2.7-image-pro': wanImageProIcon,
  'wan-2.7-image': wanImageIcon,
  'gpt-image-2': gptImage2Icon,
  'nano-banana-2-lite': nanoBanana2LiteIcon,
  'nano-banana-2': nanoBanana2Icon,
  'grok-imagine': grokImagineIcon,
}

export function resolveAiImageModelIcon(modelId) {
  return AI_IMAGE_MODEL_ICON_BY_ID[modelId] || nanoBanana2Icon
}
